/**
 * Character illustration elements — public API re-exports.
 *
 * Consumers import from here; internal structure (names, dimensions, asset
 * filenames, figma-source.json) is an implementation detail.
 */

export { characterIllustrationNames, characterIllustrationNameSet } from './names';
export type { CharacterIllustrationName } from './names';
export type { CharacterIllustrationVariant, CharacterIllustrationDimensions } from './types';
export { characterIllustrationDimensions } from './dimensions';
export { characterIllustrationAssetFiles } from './assets';
export type { CharacterIllustrationAssetFile } from './assets';
export { getCharacterIllustrationAssetFile } from './resolve';
export {
  ILLUSTRATION_TINTS,
  illustrationTintNames,
  illustrationTintNameSet,
  illustrationTintValue,
  isIllustrationTint,
} from './tints';
export type { IllustrationTint } from './tints';
export { characterIllustrationAccents, getCharacterIllustrationAccent } from './accents';
export { applyIllustrationTint } from './tint';
export { resolveAssetModule } from './resolveAssetModule';
